// Check valid date time
export default dateString => {
  if (!dateString) { return false; }
  const date = new Date(dateString);
  return (Object.prototype.toString.call(date) === '[object Date]' && !Number.isNaN(date.getTime()));
};
